/**
 * Use Navigation Items Hook
 * 
 * Determines which nav items should be visible based on access role
 * Handles role-based filtering (new_hire, employee see limited views)
 */

import { useMemo } from 'react'
import { canAccessAdminOps } from '../admin/adminConfig'
import { NAVIGATION_ITEMS_TEMPLATE } from './routes.config'

/**
 * Get visible navigation items for a given access role
 * @param {string} accessRole - User's access role
 * @returns {Array} Array of visible nav items
 */
export const getVisibleNavItems = (accessRole) => {
  const items = [...NAVIGATION_ITEMS_TEMPLATE]

  // Add admin ops if user has access
  if (canAccessAdminOps(accessRole)) {
    items.push({ key: 'admin_ops', label: 'Admin Ops' })
  }

  // Restrict new_hire and employee to limited views
  if (accessRole === 'new_hire' || accessRole === 'employee') {
    return items.filter((item) => item.key === 'home' || item.key === 'announcements')
  }

  return items
}

/**
 * Hook for calculating visible navigation based on access role
 * @param {string} accessRole - User's access role
 * @returns {Array} Memoized visible nav items
 */
export const useVisibleNavItems = (accessRole) => {
  return useMemo(() => getVisibleNavItems(accessRole), [accessRole])
}
